export const TYPE_OPTIONS = [
  { value: 'COMMUNITY', label: 'Comunidade' },
  { value: 'CREATOR', label: 'Criador' },
  { value: 'FORMAT', label: 'Formato' },
  { value: 'TREND', label: 'Tendência' },
  { value: 'AESTHETIC', label: 'Estética' },
  { value: 'SUBJECT', label: 'Assunto' },
] as const

export const DEFAULT_FORM_VALUES = {
  title: '',
  content: '',
  type: 'COMMUNITY' as const,
  url: '',
  trends: [] as string[],
  territories: [] as string[],
  contexts: [] as string[],
  topics: [] as string[],
}

export const MODAL_TITLE = 'Novo Conteúdo'
export const MODAL_DESCRIPTION = 'Adicione um novo conteúdo ao Culture Monitor.'
